import React, { useState, useEffect } from 'react';
import Notifications from '../../services/Notifications';
import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';
import Loading from '../Loading';
import UserService from '../../services/UserService';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Popper from '@mui/material/Popper';
import Checkbox from '@mui/material/Checkbox';

const Clone = ({
    user,
    usersToClone,
    updateUsersToClone,
    setUsersToClone,
    isRoleClone,
    setIsRoleClone,
    StorefrontConfig
}) => {
    const [customers, setCustomers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState(updateUsersToClone || []);
    useEffect(() => {
        const fetchCustomers = async () => {
            await UserService.getCustomers(user.id, setCustomers);
        };
        fetchCustomers();
    }, [user.id]);

    const handleClonedUsersChange = (e, values) => {
        const ids = values.map(x => x.id);
        setSelectedUsers(ids);
        setUsersToClone(ids);
    };

    if (!StorefrontConfig.storefrontSettingsLoaded) {
        return <Loading type="brand" />;
    }

    return (
        <>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>User To Clone</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: 'fit-content' }}>
                <Box>
                    <Typography variant="h4" style={{ marginLeft: "10px" }}>{user.email}</Typography>
                    <Typography variant="h5" style={{ marginLeft: "10px" }}>{"Customers: " + customers.length}</Typography>
                </Box>
                <Box>
                    <Typography variant="h5" style={{ marginLeft: "10px", marginTop: "15%" }}>
                        {"Secondary Email: "} {user.secondaryEmail || "N/A"}
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'center', width: 'fit-content' }}>
                <Box>
                    <Typography variant="h6" sx={{ marginTop: "5px", fontWeight: "bold" }}>Clone Permissions</Typography>
                </Box>
                <Box>
                    <Checkbox
                        onChange={setIsRoleClone}
                        checked={isRoleClone}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                </Box>
            </Box>

            <br /><br />
            <Autocomplete
                multiple
                id="tags-standard"
                size="lg"
                disablePortal
                PopperComponent={(props) => (
                    <Popper {...props} placement="bottom-start">
                        {props.children}
                    </Popper>
                )}
                options={usersToClone}
                getOptionLabel={(option) => option.email}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                        <Chip
                            label={option.email}
                            {...getTagProps({ index })}
                            sx={{
                                background: 'white',
                                color: 'black',
                                fontSize: "15px",
                                height: "100%",
                                width: '100%',
                                padding: "10px"
                            }}
                        />
                    ))
                }
                onChange={handleClonedUsersChange}
                defaultValue={selectedUsers}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Clone To"
                    />
                )}
            />
        </>
    );
};
function notValid(message) {
    Notifications.error(message);
    return false;
}
export default withStorefrontConfig(Clone);